<template>
  <div class="project-operation">
    <div class="module-header">
      <div class="module-title">常见中小微企业承接项目的痛点场景</div>
    </div>
    <div class="module-body">
      <div class="roll-row" v-for="(row, rowIdx) in renderList" :key="rowIdx">
        <div class="roll-row-inner" :style="{ width: `${row.length * 348}px` }">
          <div class="data-item" v-for="(item, index) in row" :key="index">{{ item }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataList: [
        [
          // 资质与准入
          '接政府项目，资质等级不够，拿不到投标资格',
          '参与特定行业项目，无专项资质，直接被筛除',
          '资质升级周期长，新政策下达标难度陡增',
          // 人力与技术
          '项目要临时补设计，外聘人员成本高 ',
          '施工缺专业技工，赶工易出质量风险',
          '旺季缺人手，全职雇人怕淡季闲置',
          // 经验与信任
          '没大型项目案例，客户质疑交付能力 ',
          '过往小项目多，难证明复杂项目把控力',
          '新客户合作，因无行业口碑难破冰',
        ],
        [
          // 履约与风险
          '项目突发变更，合同外增成本难核算',
          '天气等不可抗力，延误赔偿风险大',
          '验收标准模糊，客户挑刺难回款',
          // 管理与协同
          '多项目并行，资源调配容易冲突',
          '跨部门沟通慢，影响项目推进节奏',
          '分包商管理弱，质量进度难把控',
          // 市场与竞争
          '同行低价抢单，利润空间被挤压',
          '新兴业务领域，没经验不敢贸然进',
          '客户压价太狠，做项目勉强保本',
          // 创新与转型
          '想数字化转型，缺适配管理系统',
          '尝试新工艺，怕失败承担试错成本',
          '紧跟行业趋势，人才储备跟不上',
        ],
        [
          // 信息与获客
          '找项目靠老渠道，信息滞后错过先机',
          '平台推送项目，和企业需求难匹配',
          '同行人脉少，难获取一手项目线索',
          // 资金与垫资
          '项目前期要大额保证金，现金流吃紧',
          '材料款得预先垫付，回款慢压资金',
          '客户付款周期长，垫资压力层层传导',
          // 采购与议价
          '采购量小，材料商不愿给低价',
          '急单补货，供应商坐地起价',
          '想囤货降本，没资金储备不敢动',
        ]
      ],
      renderList: []
    }
  },
  created() {
    this.renderList = this.dataList.map(row => row.concat(row));
  }
};
</script>

<style lang="less" scoped>
.project-operation {
  height: 584px;
  padding-top: 64px;
  background-image: url('@/assets/img/cooperation/PainPointScenario/background.png');
  background-position: center;
  background-size: cover;

  .module-title {
    background: linear-gradient(to right, #FFC670 0%, #FF8100 100%);
    background-clip: text;
    color: transparent;
  }
  .module-body {
    margin-top: 30px;
    .roll-row {
      padding: 25px 0;
      overflow: hidden;
      .roll-row-inner {
        display: flex;
        animation: roll 50s linear infinite;
        &:hover {
          animation-play-state: paused;
        }
        @keyframes roll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        @keyframes roll-reverse {
          0% {
            transform: translateX(-50%);
          }
          100% {
            transform: translateX(0);
          }
        }
        .data-item {
          width: 284px;
          height: 76px;
          margin-left: 64px;
          padding: 18px 20px;
          color: #fff;
          font-size: 14px;
          background-image: url('@/assets/img/cooperation/PainPointScenario/item_bg.png');
          background-size: 100% 100%;
          user-select: none;
        }
      }
      &:nth-child(even) .roll-row-inner {
        animation: roll-reverse 60s linear infinite;
        &:hover {
          animation-play-state: paused;
        }
      }
    }
  }
}
</style>
